module.exports = [{"type":"title","text":"2023-07-29"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"normal","text":"support TAKE_PROFIT/STOP order type in  USDT-M Perp Futures"},{"type":"normal","text":"support customized field: clientOrderId  in both USDT-M Perp Futures and Spot"},{"type":"normal","text":"support batch placing orders in Spot"},{"type":"normal","text":"support kline api in Spot"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2023-07-29.json
// module id = IOcs
// module chunks = 3